/**
 * Метки конспекта под одной репликой: под нашей — «? тема», «дали: …», «ждём ответа»; под репликой
 * клиентки — «тема: ответила — «фрагмент»» / «обошла» / «не знает» / «неясно».
 */
import type { LabKonspektOutcome, LabKonspektTurn } from "@/lib/voiceLab";

export const ТЕМЫ: Record<string, string> = {
  event_date: "дата мероприятия",
  occasion: "повод",
  city: "город",
  visit_day: "день визита",
  phone: "номер",
  size: "размер",
  questions_left: "остались ли вопросы",
};
export const ИСХОДЫ: Record<LabKonspektOutcome, string> = {
  answered: "ответила",
  unknown: "не знает",
  unclear: "неясно",
  dodged: "обошла",
  no_reply: "ждём ответа",
};
const ЦВЕТ: Record<LabKonspektOutcome, string> = {
  answered: "text-ok",
  unknown: "text-err",
  unclear: "text-warn",
  dodged: "text-warn",
  no_reply: "text-fg-muted",
};
const чип = "rounded-full border border-border px-2 py-0.5 text-[11.5px]";
const тема = (t: string) => ТЕМЫ[t] ?? t;

export function KonspektChips({
  turn,
  className = "",
}: {
  turn: LabKonspektTurn | null | undefined;
  className?: string;
}) {
  if (!turn) return null;
  const вопросы = turn.questions ?? [];
  const дали = turn.given ?? [];
  const исходы = turn.outcomes ?? [];
  if (!вопросы.length && !дали.length && !исходы.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-annot="метки конспекта">
      {вопросы.map((q, n) => (
        <span key={`q${n}`} className={`${чип} text-accent`} title={q.sentence}>
          ? {q.topics.map(тема).join(", ") || "без темы"}
          <span className="text-fg-muted"> · «{q.sentence.length > 50 ? `${q.sentence.slice(0, 50)}…` : q.sentence}»</span>
        </span>
      ))}
      {дали.length > 0 && <span className={`${чип} text-fg-muted`}>дали: {дали.join(", ")}</span>}
      {исходы.map((o, n) => (
        <span key={`o${n}`} className={`${чип} ${ЦВЕТ[o.outcome] ?? "text-fg-muted"}`}>
          {o.outcome === "no_reply" ? (
            ИСХОДЫ.no_reply
          ) : (
            <>
              {тема(o.topic)}: {ИСХОДЫ[o.outcome] ?? o.outcome}
              {o.fragment && <span className="text-fg-muted"> — «{o.fragment}»</span>}
            </>
          )}
        </span>
      ))}
    </div>
  );
}
